import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/asuetos/asuetos';
import CrearEditar from './CrearEditar';

const ms2p = (state) => {
  return {
    ...state.asuetos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CrearEditar);
